module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/f4fdd6d001e44fd1d32e722014261af0.png";